<template>
    <b-container>
        <div class="feature-backdrop">
            <router-link :to="{ name: 'events' }" class="mr-2 mb-2 text-white">Event Registration</router-link>
        </div>
        <div
            v-if="!event"
            class="alert alert-info my-2"
        >
            <h3>
                <font-awesome-icon icon="calendar-times"></font-awesome-icon>
                {{ error.detail || 'No event was found with the given ID.' }}
            </h3>
        </div>
        <div
            v-else-if="!event.registration_open"
            class="alert alert-info my-2"
        >
            <h3>
                <font-awesome-icon icon="calendar-times"></font-awesome-icon>
                Event Registration Closed
            </h3>
            <i>This event is closed for registration at this time.</i>
        </div>
        <EventInfo
            v-if="event"
            :event="event"
        ></EventInfo>
        <b-card
            v-if="!user && event"
            class="mt-2"
        >
            <b-form-group>
                <b-form-group
                    id="first-name"
                >
                    <template #label>
                        <b>First Name</b>
                    </template>
                    <b-input v-model="public_user_info.first_name" placeholder="First Name" required />
                </b-form-group>
                <b-form-group
                    id="first-name"
                >
                    <template #label>
                        <b>Last Name</b>
                    </template>
                    <b-input v-model="public_user_info.last_name" placeholder="Last Name" required />
                </b-form-group>
                <b-form-group
                    id="email"
                >
                    <template #label>
                        <b>Email</b>
                    </template>
                    <b-input v-model="public_user_info.email" placeholder="Email" required type="email" />
                </b-form-group>
                <!-- <b-form-group
                    id="attendees"
                >
                    <template #label>
                        <b>Attendee Name(s)</b>
                    </template>
                    <b-input v-model="attendee_names" placeholder="Please include names of attendees" />
                </b-form-group> -->
            </b-form-group>
        </b-card>
        <template
            v-if="event && event.registration_open && event.ticket_settings"
        >
            <template
                v-if="event.tickets_left == 'UNLIMITED' || event.tickets_left > 0"
            >
                <template
                    v-if="!event.ticket_settings.max_user_tickets || !event.user_ticket_count || event.user_ticket_count < event.ticket_settings.max_user_tickets"
                >
                    <div
                        v-if="event.ticket_settings.show_tickets_left"
                        class="alert alert-info my-2"
                    >
                        <font-awesome-icon
                            icon="info-circle"
                        ></font-awesome-icon>
                        {{ event.tickets_left }} tickets left!
                    </div>
                    <div class="card mt-2">
                        <div class="card-body">
                            <b-form-group>
                                <label>
                                    <b>Ticket request:</b>
                                    <em
                                        v-if="event.ticket_settings.max_user_tickets && event.ticket_settings.show_user_ticket_limit"
                                    >limit {{ event.ticket_settings.max_user_tickets }} per user</em>
                                </label>
                                <b-input v-model.number="tickets_wanted" type="number" :max="event.ticket_settings.max_user_tickets" />
                                <div class="text-center mt-2">
                                    <button
                                        class="sc-btn sc-btn-lg"
                                        @click="registerEvent()"
                                    >
                                        <font-awesome-icon
                                            icon="ticket-alt"
                                            class="mr-1"
                                        ></font-awesome-icon>
                                        Get Tickets
                                    </button>
                                </div>
                            </b-form-group>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="alert alert-info mt-2">
                        <b>
                            <font-awesome-icon
                                icon="info-circle"
                            ></font-awesome-icon>
                            You have reached the maximum amount of tickets allowed per family.
                        </b>
                        <i
                            v-if="event.ticket_settings.allow_user_ticket_requests_after_max"
                        >
                            Additional tickets may be requested at this time, but are not guaranteed as space is limited.
                        </i>
                        <i
                            v-else
                        >
                            Additional tickets may not be requested at this time.
                        </i>
                    </div>
                    <div
                        v-if="event.ticket_settings.allow_user_ticket_requests_after_max"
                        class="card mt-2"
                    >
                        <div class="card-body">
                            
                            <b-form-group
                                id="tickets_wanted"
                            >
                                <template #label>
                                    <b>Ticket request:</b><em> How many additional tickets would you like for this event?</em>
                                </template>
                                <b-input v-model.number="tickets_wanted" type="number" />
                            </b-form-group>

                            <div class="text-center mt-2">
                                <button
                                    class="sc-btn sc-btn-lg"
                                    @click="registerEvent()"
                                >
                                    <font-awesome-icon
                                        icon="ticket-alt"
                                        class="mr-1"
                                    ></font-awesome-icon>
                                    Request Tickets
                                </button>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
            <template v-else-if="event.ticket_settings">
                <div class="alert alert-info mt-2">
                    <b>
                        <font-awesome-icon
                            icon="info-circle"
                        ></font-awesome-icon>
                        No tickets are available for this event.
                    </b>
                    <i
                        v-if="event.ticket_settings.allow_user_ticket_requests_after_full"
                    >
                        Tickets may still be requested as additional tickets may become available.
                    </i>
                </div>
                <div
                    v-if="event.ticket_settings.allow_user_ticket_requests_after_full"
                    class="card"
                >
                    <div class="card-body">
                        <b-form-group>
                            <h3>Ticket Request</h3>
                            <label><em> How many tickets would you like for this event?</em></label>
                            <b-form-input v-model.number="tickets_wanted" type="number" />

                            <div class="text-center">
                                <button
                                    class="sc-btn sc-btn-lg mt-2"
                                    @click="registerEvent()"
                                >
                                    <font-awesome-icon
                                        icon="ticket-alt"
                                        class="mr-1"
                                    ></font-awesome-icon>
                                    Request Tickets
                                </button>
                            </div>
                        </b-form-group>
                    </div>
                </div>
            </template>
        </template>
    </b-container>
</template>
<script>
import { mapState } from 'vuex';
import EventInfo    from "./EventInfo.vue"
import { isAxiosError } from "axios"

export default {
    props: [ "id" ],
    data() {
        return {
            tickets_wanted: 1,
            event: {},
            public_user_info: {},
            error: { detail: "" }
        };
    },
    mounted() {
        this.loadEvent();
    },
    methods: {
        loadEvent() {
            this.$api.get(
                `/api/events/get/${this.id}`
            ).then((response) => {
                if (response.status == 200) {
                    this.event = response.data.event;
                    this.event.ticket_settings = (this.event.ticket_settings || {});
                } else {
                    this.event = null;
                    this.error.detail = response.data.message;
                }
            }).catch((e) => {
                if (isAxiosError(e)) {
                    this.error.detail = e.response.data.message;
                } else {
                    this.error.detail = e.message;
                }
                alert(this.error.detail);
            });
        },
        validatePublicUser() {
            if (this.public_user_info.first_name && this.public_user_info.last_name && this.public_user_info.email) return true;

            this.$bvToast.toast("First name, Last name, and Email are required fields.", {
                title           : "Notification",
                autoHideDelay   : 5000,
                appendToast     : true,
                variant: "danger"
            });

            return false;
        },
        registerEvent() {
            // public_user_info
            let request;
            if (this.user) {
                request = this.$api.post(
                    `/api/events/register/${this.id}`,
                    {
                        tickets_wanted: this.tickets_wanted
                    }
                );
            } else {
                if (!this.validatePublicUser()) return;

                request = this.$api.post(
                    `/api/events/register-public/${this.id}`,
                    {
                        public_user: this.public_user_info,
                        tickets_wanted: this.tickets_wanted
                    },
                    { withCredentials: true }
                );
            }
            
            request.then((response) => {
                this.$bvToast.toast(response.data.message, {
                    title           : "Notification",
                    autoHideDelay   : 5000,
                    appendToast     : true
                });
                this.$router.push({ name: "view_event_tickets", params: { id: this.id } });
            }).catch(() => {
                this.$bvToast.toast("Error registering for event. Please retry or contact system administrator.", {
                    title           : "Notification",
                    autoHideDelay   : 5000,
                    appendToast     : true,
                    variant: "danger"
                });
            })
        }
    },
    computed: mapState(["user"]),
    components: { EventInfo }
}
</script>